module.exports = __webpack_public_path__ + "img/749.7f619925.jpg";